export default __webpack_public_path__ + "static/media/bannerAudirotira.c6845a50.svg";